import { FC, useMemo } from 'react';
import { EEventDetailsAllowedActions } from 'data/types/events.types';
import { Col, Row } from 'components/Base/Grid';
import { TActionsGroupProps } from './Actions.types';
import PublishAction from './PublishAction';
import ActionsGroupButton from './ActionsGroupButton';
import RescheduleAction from './RescheduleAction';
import RepublishAction from './RepublishAction';

const Actions: FC<TActionsGroupProps> = ({ id, data }) => {
  const noCoordinators = useMemo(() => {
    const hasSite = (data?.siteCoordinators?.length ?? 0) > 0;
    const hasEvent = (data?.eventCoordinators?.length ?? 0) > 0;
    return !hasSite && !hasEvent;
  }, [data?.siteCoordinators?.length, data?.eventCoordinators?.length]);

  const incompleteSessionDates = useMemo(() => {
    return (
      data?.parts?.some(
        part => !part.date?.value || !part.startTime || !part.endTime,
      ) ?? false
    );
  }, [data?.parts]);

  const noDescription = useMemo(() => {
    return !data?.description?.value;
  }, [data?.description]);

  // ELC specific validations (only for non-virtual events)
  const noLocation = useMemo(() => {
    const isELC = data?.host?.hostType === 'ELC';
    const isVirtual = data?.attendanceType === 'VIRTUAL';
    return isELC && !isVirtual && !data?.location?.address?.id;
  }, [data?.host?.hostType, data?.attendanceType, data?.location?.address?.id]);

  const noMeetingLink = useMemo(() => {
    const isVirtual = data?.attendanceType === 'VIRTUAL';
    return isVirtual && !data?.meetingLink?.value;
  }, [data?.attendanceType, data?.meetingLink?.value]);

  const isPublishDisabled = useMemo(() => {
    return (
      noCoordinators ||
      incompleteSessionDates ||
      noDescription ||
      noLocation ||
      noMeetingLink
    );
  }, [
    noCoordinators,
    incompleteSessionDates,
    noDescription,
    noLocation,
    noMeetingLink,
  ]);

  return (
    <Row gutter={[16, 16]}>
      {data?.allowedActions?.includes(EEventDetailsAllowedActions.PUBLISH) && (
        <Col>
          <PublishAction id={id} disabled={isPublishDisabled} />
        </Col>
      )}
      {data?.allowedActions?.includes(
        EEventDetailsAllowedActions.RESCHEDULE,
      ) && (
        <Col>
          <RescheduleAction id={id} />
        </Col>
      )}
      {data?.allowedActions?.includes(
        EEventDetailsAllowedActions.REPUBLISH,
      ) && (
        <Col>
          <RepublishAction id={id} />
        </Col>
      )}
      <Col>
        <ActionsGroupButton id={id} data={data} />
      </Col>
    </Row>
  );
};

export default Actions;
